<template>
  <div class="pdf-zoom">
    <v-tooltip top>
      <v-btn @click.prevent.stop="zoomOut"
        :disabled="isDisabled"
        slot="activator" flat dark small fab>
        <v-icon medium>mdi-magnify-minus-outline</v-icon>
      </v-btn>
      <span>Diminuir zoom</span>
    </v-tooltip>
    <!---->
    <v-tooltip top>
      <v-btn @click.prevent.stop="zoomIn"
             :disabled="isDisabled"
             slot="activator" flat dark small fab>
        <v-icon medium>mdi-magnify-plus-outline</v-icon>

      </v-btn>
      <span>Diminuir zoom</span>
    </v-tooltip>
    <!---->
    <v-tooltip top>
      <v-btn @click.prevent.stop="fitWidth"
             :disabled="isDisabled"
             slot="activator" flat dark small fab>
        <v-icon medium>mdi-fullscreen</v-icon>
      </v-btn>
      <span>Ajustar a largura</span>
    </v-tooltip>
    <!---->
    <v-tooltip top>
      <v-btn @click.prevent.stop="fitAuto"
             :disabled="isDisabled"
             slot="activator" flat dark small fab>
        <v-icon medium>mdi-fullscreen-exit</v-icon>
      </v-btn>
      <span>Redefinir zoom</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'PDFZoom',
  props: {
    scale: {
      type: Number,
    },
    increment: {
      type: Number,
      default: 0.25,
    },
  },
  computed: {
    isDisabled() {
      return !this.scale;
    },
  },
  methods: {
    zoomIn() {
      this.updateScale(this.scale + this.increment);
    },

    zoomOut() {
      if (this.scale <= this.increment) return;
      this.updateScale(this.scale - this.increment);
    },

    updateScale(scale) {
      this.$emit('change', { scale });
    },

    fitWidth() {
      this.$emit('fit', 'width');
    },

    fitAuto() {
      this.$emit('fit', 'auto');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pdf/PDFZoom.vue